import { createEventTracker } from '@core/tracking';

export type LandingPageEvent = 'web_go_to_wow_campaign_click';

export const useTrackEvent =
  createEventTracker<LandingPageEvent>('LandingPage');
